import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LoaderIcon } from "lucide-react";

import { UsageSettings } from "../components/settings/UsageSettings";
import { useAdministrativeAccess } from "../components/settings/useAdministrativeAccess";

function SettingsUsageRoute() {
  const { hasAccess, isPending } = useAdministrativeAccess();
  if (isPending) {
    return (
      <div className="flex flex-1 items-center justify-center text-muted-foreground/40">
        <LoaderIcon className="size-4 animate-spin" />
      </div>
    );
  }
  if (!hasAccess) {
    return <Navigate to="/settings/general" replace />;
  }
  return <UsageSettings />;
}

export const Route = createFileRoute("/settings/usage")({
  component: SettingsUsageRoute,
});
